import { useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { getGraphData } from "../../store/api/admin/NewDashboardApi";

const StatisticsChart = () => {
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGraph = async () => {
      setLoading(true);
      try {
        const res = await getGraphData();
        setGraphData(res?.data || []);
      } catch (err) {
        console.error("Graph API failed", err);
        setError("Failed to load graph");
      } finally {
        setLoading(false);
      }
    };

    fetchGraph();
  }, []);

  // ✅ Aggregate subcategory counts across ALL months
  const aggregatedSubcategories = useMemo(() => {
    if (!Array.isArray(graphData) || !graphData.length) return [];

    const map = {};

    graphData.forEach((month) => {
      month.subcategories?.forEach(({ subcategory, count }) => {
        map[subcategory] = (map[subcategory] || 0) + count;
      });
    });

    // Convert object → array & sort by highest count
    return Object.entries(map)
      .map(([subcategory, count]) => ({ subcategory, count }))
      .sort((a, b) => b.count - a.count);
  }, [graphData]);

  if (loading) return <p>Loading chart...</p>;
  if (error) return <p>{error}</p>;
  if (!aggregatedSubcategories.length) return <p>No data available</p>;

  const categories = aggregatedSubcategories.map((s) => s.subcategory);
  const counts = aggregatedSubcategories.map((s) => s.count);

  const options = {
    chart: {
      type: "area",
      toolbar: { show: false },
    },
    title: {
      text: "Total Leads by Subcategory",
    },
    xaxis: {
      categories,
      title: { text: "Subcategories" },
    },
    yaxis: {
      min: 0,
      title: { text: "Leads Count" },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    fill: {
      type: "gradient",
      gradient: {
        opacityFrom: 0.6,
        opacityTo: 0.1,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 4,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} leads`,
      },
    },
  };

  const series = [
    {
      name: "Leads",
      data: counts,
    },
  ];

  return <Chart options={options} series={series} type="area" height={300} />;
};

export default StatisticsChart;
